// source: proto/reportpb/exercisedeclaration.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_type_date_pb = require('../../google/type/date_pb.js');
goog.object.extend(proto, google_type_date_pb);
var proto_utilspb_pagination_pb = require('../../proto/utilspb/pagination_pb.js');
goog.object.extend(proto, proto_utilspb_pagination_pb);
goog.exportSymbol('proto.reportpb.CreateExerciseDeclarationRequest', null, global);
goog.exportSymbol('proto.reportpb.CreateExerciseDeclarationResponse', null, global);
goog.exportSymbol('proto.reportpb.CreateExerciseNoticeRequest', null, global);
goog.exportSymbol('proto.reportpb.CreateExerciseNoticeResponse', null, global);
goog.exportSymbol('proto.reportpb.ExerciseDeclaration', null, global);
goog.exportSymbol('proto.reportpb.ExerciseDeclarationDetails', null, global);
goog.exportSymbol('proto.reportpb.ListExerciseDeclarationRequest', null, global);
goog.exportSymbol('proto.reportpb.ListExerciseDeclarationResponse', null, global);
goog.exportSymbol('proto.reportpb.ListExerciseDeclarationSummary', null, global);
goog.exportSymbol('proto.reportpb.ReadExerciseDeclarationRequest', null, global);
goog.exportSymbol('proto.reportpb.ReadExerciseDeclarationResponse', null, global);
goog.exportSymbol('proto.reportpb.ReadExerciseNoticeRequest', null, global);
goog.exportSymbol('proto.reportpb.ReadExerciseNoticeResponse', null, global);
goog.exportSymbol('proto.reportpb.ReadExerciseNoticeSummary', null, global);
goog.exportSymbol('proto.reportpb.UpdateExerciseDeclarationRequest', null, global);
goog.exportSymbol('proto.reportpb.UpdateExerciseDeclarationResponse', null, global);
goog.exportSymbol('proto.reportpb.UpdateExerciseNoticeRequest', null, global);
goog.exportSymbol('proto.reportpb.UpdateExerciseNoticeResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ExerciseDeclaration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.ExerciseDeclaration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ExerciseDeclaration.displayName = 'proto.reportpb.ExerciseDeclaration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ListExerciseDeclarationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.ListExerciseDeclarationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ListExerciseDeclarationRequest.displayName = 'proto.reportpb.ListExerciseDeclarationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ListExerciseDeclarationSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.ListExerciseDeclarationSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ListExerciseDeclarationSummary.displayName = 'proto.reportpb.ListExerciseDeclarationSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ListExerciseDeclarationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.reportpb.ListExerciseDeclarationResponse.repeatedFields_, null);
};
goog.inherits(proto.reportpb.ListExerciseDeclarationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ListExerciseDeclarationResponse.displayName = 'proto.reportpb.ListExerciseDeclarationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.CreateExerciseDeclarationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.CreateExerciseDeclarationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.CreateExerciseDeclarationRequest.displayName = 'proto.reportpb.CreateExerciseDeclarationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.CreateExerciseDeclarationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.CreateExerciseDeclarationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.CreateExerciseDeclarationResponse.displayName = 'proto.reportpb.CreateExerciseDeclarationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.UpdateExerciseDeclarationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.UpdateExerciseDeclarationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.UpdateExerciseDeclarationRequest.displayName = 'proto.reportpb.UpdateExerciseDeclarationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.UpdateExerciseDeclarationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.UpdateExerciseDeclarationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.UpdateExerciseDeclarationResponse.displayName = 'proto.reportpb.UpdateExerciseDeclarationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.CreateExerciseNoticeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.CreateExerciseNoticeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.CreateExerciseNoticeRequest.displayName = 'proto.reportpb.CreateExerciseNoticeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.CreateExerciseNoticeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.CreateExerciseNoticeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.CreateExerciseNoticeResponse.displayName = 'proto.reportpb.CreateExerciseNoticeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.UpdateExerciseNoticeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.UpdateExerciseNoticeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.UpdateExerciseNoticeRequest.displayName = 'proto.reportpb.UpdateExerciseNoticeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.UpdateExerciseNoticeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.UpdateExerciseNoticeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.UpdateExerciseNoticeResponse.displayName = 'proto.reportpb.UpdateExerciseNoticeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ExerciseDeclarationDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.ExerciseDeclarationDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ExerciseDeclarationDetails.displayName = 'proto.reportpb.ExerciseDeclarationDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ReadExerciseDeclarationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.ReadExerciseDeclarationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ReadExerciseDeclarationRequest.displayName = 'proto.reportpb.ReadExerciseDeclarationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ReadExerciseDeclarationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.reportpb.ReadExerciseDeclarationResponse.repeatedFields_, null);
};
goog.inherits(proto.reportpb.ReadExerciseDeclarationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ReadExerciseDeclarationResponse.displayName = 'proto.reportpb.ReadExerciseDeclarationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ReadExerciseNoticeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.ReadExerciseNoticeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ReadExerciseNoticeRequest.displayName = 'proto.reportpb.ReadExerciseNoticeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ReadExerciseNoticeSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.ReadExerciseNoticeSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ReadExerciseNoticeSummary.displayName = 'proto.reportpb.ReadExerciseNoticeSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ReadExerciseNoticeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.reportpb.ReadExerciseNoticeResponse.repeatedFields_, null);
};
goog.inherits(proto.reportpb.ReadExerciseNoticeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ReadExerciseNoticeResponse.displayName = 'proto.reportpb.ReadExerciseNoticeResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ExerciseDeclaration.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ExerciseDeclaration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ExerciseDeclaration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ExerciseDeclaration.toObject = function(includeInstance, msg) {
  var f, obj = {
    contraryId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    accountId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    correspondent: jspb.Message.getFieldWithDefault(msg, 3, ""),
    accountName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    rep: jspb.Message.getFieldWithDefault(msg, 5, ""),
    branch: jspb.Message.getFieldWithDefault(msg, 6, ""),
    accountNo: jspb.Message.getFieldWithDefault(msg, 7, ""),
    marginType: jspb.Message.getFieldWithDefault(msg, 8, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 9, ""),
    symbolDescription: jspb.Message.getFieldWithDefault(msg, 10, ""),
    originalCusip: jspb.Message.getFieldWithDefault(msg, 11, ""),
    tdQty: jspb.Message.getFieldWithDefault(msg, 12, ""),
    exerciseQty: jspb.Message.getFieldWithDefault(msg, 13, ""),
    eed: jspb.Message.getFieldWithDefault(msg, 14, ""),
    dned: jspb.Message.getFieldWithDefault(msg, 15, ""),
    systemDate: (f = msg.getSystemDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    expirationDate: jspb.Message.getFieldWithDefault(msg, 17, ""),
    reportPositionId: jspb.Message.getFieldWithDefault(msg, 18, 0),
    subAccountNo: jspb.Message.getFieldWithDefault(msg, 19, ""),
    status: jspb.Message.getFieldWithDefault(msg, 20, ""),
    positionQty: jspb.Message.getFieldWithDefault(msg, 21, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ExerciseDeclaration}
 */
proto.reportpb.ExerciseDeclaration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ExerciseDeclaration;
  return proto.reportpb.ExerciseDeclaration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ExerciseDeclaration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ExerciseDeclaration}
 */
proto.reportpb.ExerciseDeclaration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setContraryId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorrespondent(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setRep(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setBranch(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNo(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarginType(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolDescription(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setOriginalCusip(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setTdQty(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setExerciseQty(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setEed(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setDned(value);
      break;
    case 16:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setSystemDate(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setExpirationDate(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setReportPositionId(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubAccountNo(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setPositionQty(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ExerciseDeclaration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ExerciseDeclaration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ExerciseDeclaration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ExerciseDeclaration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContraryId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getCorrespondent();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAccountName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRep();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getBranch();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAccountNo();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getMarginType();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getSymbolDescription();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getOriginalCusip();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getTdQty();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getExerciseQty();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getEed();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getDned();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getSystemDate();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getExpirationDate();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getReportPositionId();
  if (f !== 0) {
    writer.writeUint32(
      18,
      f
    );
  }
  f = message.getSubAccountNo();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getPositionQty();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
};


/**
 * optional uint32 contrary_id = 1;
 * @return {number}
 */
proto.reportpb.ExerciseDeclaration.prototype.getContraryId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.ExerciseDeclaration} returns this
 */
proto.reportpb.ExerciseDeclaration.prototype.setContraryId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 account_id = 2;
 * @return {number}
 */
proto.reportpb.ExerciseDeclaration.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.ExerciseDeclaration} returns this
 */
proto.reportpb.ExerciseDeclaration.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string correspondent = 3;
 * @return {string}
 */
proto.reportpb.ExerciseDeclaration.prototype.getCorrespondent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ExerciseDeclaration} returns this
 */
proto.reportpb.ExerciseDeclaration.prototype.setCorrespondent = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string account_name = 4;
 * @return {string}
 */
proto.reportpb.ExerciseDeclaration.prototype.getAccountName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ExerciseDeclaration} returns this
 */
proto.reportpb.ExerciseDeclaration.prototype.setAccountName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string rep = 5;
 * @return {string}
 */
proto.reportpb.ExerciseDeclaration.prototype.getRep = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ExerciseDeclaration} returns this
 */
proto.reportpb.ExerciseDeclaration.prototype.setRep = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string branch = 6;
 * @return {string}
 */
proto.reportpb.ExerciseDeclaration.prototype.getBranch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ExerciseDeclaration} returns this
 */
proto.reportpb.ExerciseDeclaration.prototype.setBranch = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string account_no = 7;
 * @return {string}
 */
proto.reportpb.ExerciseDeclaration.prototype.getAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ExerciseDeclaration} returns this
 */
proto.reportpb.ExerciseDeclaration.prototype.setAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string margin_type = 8;
 * @return {string}
 */
proto.reportpb.ExerciseDeclaration.prototype.getMarginType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ExerciseDeclaration} returns this
 */
proto.reportpb.ExerciseDeclaration.prototype.setMarginType = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string symbol = 9;
 * @return {string}
 */
proto.reportpb.ExerciseDeclaration.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ExerciseDeclaration} returns this
 */
proto.reportpb.ExerciseDeclaration.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string symbol_description = 10;
 * @return {string}
 */
proto.reportpb.ExerciseDeclaration.prototype.getSymbolDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ExerciseDeclaration} returns this
 */
proto.reportpb.ExerciseDeclaration.prototype.setSymbolDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string original_cusip = 11;
 * @return {string}
 */
proto.reportpb.ExerciseDeclaration.prototype.getOriginalCusip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ExerciseDeclaration} returns this
 */
proto.reportpb.ExerciseDeclaration.prototype.setOriginalCusip = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string td_qty = 12;
 * @return {string}
 */
proto.reportpb.ExerciseDeclaration.prototype.getTdQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ExerciseDeclaration} returns this
 */
proto.reportpb.ExerciseDeclaration.prototype.setTdQty = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string exercise_qty = 13;
 * @return {string}
 */
proto.reportpb.ExerciseDeclaration.prototype.getExerciseQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ExerciseDeclaration} returns this
 */
proto.reportpb.ExerciseDeclaration.prototype.setExerciseQty = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string eed = 14;
 * @return {string}
 */
proto.reportpb.ExerciseDeclaration.prototype.getEed = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ExerciseDeclaration} returns this
 */
proto.reportpb.ExerciseDeclaration.prototype.setEed = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string dned = 15;
 * @return {string}
 */
proto.reportpb.ExerciseDeclaration.prototype.getDned = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ExerciseDeclaration} returns this
 */
proto.reportpb.ExerciseDeclaration.prototype.setDned = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional google.type.Date system_date = 16;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ExerciseDeclaration.prototype.getSystemDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 16));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ExerciseDeclaration} returns this
*/
proto.reportpb.ExerciseDeclaration.prototype.setSystemDate = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ExerciseDeclaration} returns this
 */
proto.reportpb.ExerciseDeclaration.prototype.clearSystemDate = function() {
  return this.setSystemDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ExerciseDeclaration.prototype.hasSystemDate = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional string expiration_date = 17;
 * @return {string}
 */
proto.reportpb.ExerciseDeclaration.prototype.getExpirationDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ExerciseDeclaration} returns this
 */
proto.reportpb.ExerciseDeclaration.prototype.setExpirationDate = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional uint32 report_position_id = 18;
 * @return {number}
 */
proto.reportpb.ExerciseDeclaration.prototype.getReportPositionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.ExerciseDeclaration} returns this
 */
proto.reportpb.ExerciseDeclaration.prototype.setReportPositionId = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional string sub_account_no = 19;
 * @return {string}
 */
proto.reportpb.ExerciseDeclaration.prototype.getSubAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ExerciseDeclaration} returns this
 */
proto.reportpb.ExerciseDeclaration.prototype.setSubAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string status = 20;
 * @return {string}
 */
proto.reportpb.ExerciseDeclaration.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ExerciseDeclaration} returns this
 */
proto.reportpb.ExerciseDeclaration.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string position_qty = 21;
 * @return {string}
 */
proto.reportpb.ExerciseDeclaration.prototype.getPositionQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ExerciseDeclaration} returns this
 */
proto.reportpb.ExerciseDeclaration.prototype.setPositionQty = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ListExerciseDeclarationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ListExerciseDeclarationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ListExerciseDeclarationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListExerciseDeclarationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    dateType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    systemDate: (f = msg.getSystemDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    accountNo: jspb.Message.getFieldWithDefault(msg, 3, ""),
    accountName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    masterAccountNo: jspb.Message.getFieldWithDefault(msg, 5, ""),
    broker: jspb.Message.getFieldWithDefault(msg, 6, ""),
    branch: jspb.Message.getFieldWithDefault(msg, 7, ""),
    rep: jspb.Message.getFieldWithDefault(msg, 8, ""),
    correspondent: jspb.Message.getFieldWithDefault(msg, 9, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 10, ""),
    pagination: (f = msg.getPagination()) && proto_utilspb_pagination_pb.Pagination.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ListExerciseDeclarationRequest}
 */
proto.reportpb.ListExerciseDeclarationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ListExerciseDeclarationRequest;
  return proto.reportpb.ListExerciseDeclarationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ListExerciseDeclarationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ListExerciseDeclarationRequest}
 */
proto.reportpb.ListExerciseDeclarationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateType(value);
      break;
    case 2:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setSystemDate(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNo(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccountNo(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setBroker(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setBranch(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setRep(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorrespondent(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 11:
      var value = new proto_utilspb_pagination_pb.Pagination;
      reader.readMessage(value,proto_utilspb_pagination_pb.Pagination.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ListExerciseDeclarationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ListExerciseDeclarationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ListExerciseDeclarationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListExerciseDeclarationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDateType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSystemDate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getAccountNo();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAccountName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMasterAccountNo();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getBroker();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getBranch();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getRep();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCorrespondent();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto_utilspb_pagination_pb.Pagination.serializeBinaryToWriter
    );
  }
};


/**
 * optional string date_type = 1;
 * @return {string}
 */
proto.reportpb.ListExerciseDeclarationRequest.prototype.getDateType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListExerciseDeclarationRequest} returns this
 */
proto.reportpb.ListExerciseDeclarationRequest.prototype.setDateType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.type.Date system_date = 2;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ListExerciseDeclarationRequest.prototype.getSystemDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 2));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ListExerciseDeclarationRequest} returns this
*/
proto.reportpb.ListExerciseDeclarationRequest.prototype.setSystemDate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListExerciseDeclarationRequest} returns this
 */
proto.reportpb.ListExerciseDeclarationRequest.prototype.clearSystemDate = function() {
  return this.setSystemDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListExerciseDeclarationRequest.prototype.hasSystemDate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string account_no = 3;
 * @return {string}
 */
proto.reportpb.ListExerciseDeclarationRequest.prototype.getAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListExerciseDeclarationRequest} returns this
 */
proto.reportpb.ListExerciseDeclarationRequest.prototype.setAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string account_name = 4;
 * @return {string}
 */
proto.reportpb.ListExerciseDeclarationRequest.prototype.getAccountName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListExerciseDeclarationRequest} returns this
 */
proto.reportpb.ListExerciseDeclarationRequest.prototype.setAccountName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string master_account_no = 5;
 * @return {string}
 */
proto.reportpb.ListExerciseDeclarationRequest.prototype.getMasterAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListExerciseDeclarationRequest} returns this
 */
proto.reportpb.ListExerciseDeclarationRequest.prototype.setMasterAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string broker = 6;
 * @return {string}
 */
proto.reportpb.ListExerciseDeclarationRequest.prototype.getBroker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListExerciseDeclarationRequest} returns this
 */
proto.reportpb.ListExerciseDeclarationRequest.prototype.setBroker = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string branch = 7;
 * @return {string}
 */
proto.reportpb.ListExerciseDeclarationRequest.prototype.getBranch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListExerciseDeclarationRequest} returns this
 */
proto.reportpb.ListExerciseDeclarationRequest.prototype.setBranch = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string rep = 8;
 * @return {string}
 */
proto.reportpb.ListExerciseDeclarationRequest.prototype.getRep = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListExerciseDeclarationRequest} returns this
 */
proto.reportpb.ListExerciseDeclarationRequest.prototype.setRep = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string correspondent = 9;
 * @return {string}
 */
proto.reportpb.ListExerciseDeclarationRequest.prototype.getCorrespondent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListExerciseDeclarationRequest} returns this
 */
proto.reportpb.ListExerciseDeclarationRequest.prototype.setCorrespondent = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string symbol = 10;
 * @return {string}
 */
proto.reportpb.ListExerciseDeclarationRequest.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListExerciseDeclarationRequest} returns this
 */
proto.reportpb.ListExerciseDeclarationRequest.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional utilspb.Pagination pagination = 11;
 * @return {?proto.utilspb.Pagination}
 */
proto.reportpb.ListExerciseDeclarationRequest.prototype.getPagination = function() {
  return /** @type{?proto.utilspb.Pagination} */ (
    jspb.Message.getWrapperField(this, proto_utilspb_pagination_pb.Pagination, 11));
};


/**
 * @param {?proto.utilspb.Pagination|undefined} value
 * @return {!proto.reportpb.ListExerciseDeclarationRequest} returns this
*/
proto.reportpb.ListExerciseDeclarationRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListExerciseDeclarationRequest} returns this
 */
proto.reportpb.ListExerciseDeclarationRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListExerciseDeclarationRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 11) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ListExerciseDeclarationSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ListExerciseDeclarationSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ListExerciseDeclarationSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListExerciseDeclarationSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    totalRows: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ListExerciseDeclarationSummary}
 */
proto.reportpb.ListExerciseDeclarationSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ListExerciseDeclarationSummary;
  return proto.reportpb.ListExerciseDeclarationSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ListExerciseDeclarationSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ListExerciseDeclarationSummary}
 */
proto.reportpb.ListExerciseDeclarationSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTotalRows(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ListExerciseDeclarationSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ListExerciseDeclarationSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ListExerciseDeclarationSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListExerciseDeclarationSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalRows();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 total_rows = 1;
 * @return {number}
 */
proto.reportpb.ListExerciseDeclarationSummary.prototype.getTotalRows = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.ListExerciseDeclarationSummary} returns this
 */
proto.reportpb.ListExerciseDeclarationSummary.prototype.setTotalRows = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.reportpb.ListExerciseDeclarationResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ListExerciseDeclarationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ListExerciseDeclarationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ListExerciseDeclarationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListExerciseDeclarationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    exerciseDeclarationsList: jspb.Message.toObjectList(msg.getExerciseDeclarationsList(),
    proto.reportpb.ExerciseDeclaration.toObject, includeInstance),
    summary: (f = msg.getSummary()) && proto.reportpb.ListExerciseDeclarationSummary.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ListExerciseDeclarationResponse}
 */
proto.reportpb.ListExerciseDeclarationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ListExerciseDeclarationResponse;
  return proto.reportpb.ListExerciseDeclarationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ListExerciseDeclarationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ListExerciseDeclarationResponse}
 */
proto.reportpb.ListExerciseDeclarationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.reportpb.ExerciseDeclaration;
      reader.readMessage(value,proto.reportpb.ExerciseDeclaration.deserializeBinaryFromReader);
      msg.addExerciseDeclarations(value);
      break;
    case 2:
      var value = new proto.reportpb.ListExerciseDeclarationSummary;
      reader.readMessage(value,proto.reportpb.ListExerciseDeclarationSummary.deserializeBinaryFromReader);
      msg.setSummary(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ListExerciseDeclarationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ListExerciseDeclarationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ListExerciseDeclarationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListExerciseDeclarationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExerciseDeclarationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.reportpb.ExerciseDeclaration.serializeBinaryToWriter
    );
  }
  f = message.getSummary();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.reportpb.ListExerciseDeclarationSummary.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ExerciseDeclaration exercise_declarations = 1;
 * @return {!Array<!proto.reportpb.ExerciseDeclaration>}
 */
proto.reportpb.ListExerciseDeclarationResponse.prototype.getExerciseDeclarationsList = function() {
  return /** @type{!Array<!proto.reportpb.ExerciseDeclaration>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.reportpb.ExerciseDeclaration, 1));
};


/**
 * @param {!Array<!proto.reportpb.ExerciseDeclaration>} value
 * @return {!proto.reportpb.ListExerciseDeclarationResponse} returns this
*/
proto.reportpb.ListExerciseDeclarationResponse.prototype.setExerciseDeclarationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.reportpb.ExerciseDeclaration=} opt_value
 * @param {number=} opt_index
 * @return {!proto.reportpb.ExerciseDeclaration}
 */
proto.reportpb.ListExerciseDeclarationResponse.prototype.addExerciseDeclarations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.reportpb.ExerciseDeclaration, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.reportpb.ListExerciseDeclarationResponse} returns this
 */
proto.reportpb.ListExerciseDeclarationResponse.prototype.clearExerciseDeclarationsList = function() {
  return this.setExerciseDeclarationsList([]);
};


/**
 * optional ListExerciseDeclarationSummary summary = 2;
 * @return {?proto.reportpb.ListExerciseDeclarationSummary}
 */
proto.reportpb.ListExerciseDeclarationResponse.prototype.getSummary = function() {
  return /** @type{?proto.reportpb.ListExerciseDeclarationSummary} */ (
    jspb.Message.getWrapperField(this, proto.reportpb.ListExerciseDeclarationSummary, 2));
};


/**
 * @param {?proto.reportpb.ListExerciseDeclarationSummary|undefined} value
 * @return {!proto.reportpb.ListExerciseDeclarationResponse} returns this
*/
proto.reportpb.ListExerciseDeclarationResponse.prototype.setSummary = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListExerciseDeclarationResponse} returns this
 */
proto.reportpb.ListExerciseDeclarationResponse.prototype.clearSummary = function() {
  return this.setSummary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListExerciseDeclarationResponse.prototype.hasSummary = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.CreateExerciseDeclarationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.CreateExerciseDeclarationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.CreateExerciseDeclarationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.CreateExerciseDeclarationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    subAccountNo: jspb.Message.getFieldWithDefault(msg, 2, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 3, ""),
    originalCusip: jspb.Message.getFieldWithDefault(msg, 4, ""),
    eed: jspb.Message.getFieldWithDefault(msg, 5, ""),
    dned: jspb.Message.getFieldWithDefault(msg, 6, ""),
    systemDate: (f = msg.getSystemDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 8, ""),
    reportPositionId: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.CreateExerciseDeclarationRequest}
 */
proto.reportpb.CreateExerciseDeclarationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.CreateExerciseDeclarationRequest;
  return proto.reportpb.CreateExerciseDeclarationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.CreateExerciseDeclarationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.CreateExerciseDeclarationRequest}
 */
proto.reportpb.CreateExerciseDeclarationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubAccountNo(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOriginalCusip(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEed(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDned(value);
      break;
    case 7:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setSystemDate(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setReportPositionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.CreateExerciseDeclarationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.CreateExerciseDeclarationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.CreateExerciseDeclarationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.CreateExerciseDeclarationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getSubAccountNo();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOriginalCusip();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEed();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDned();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSystemDate();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getReportPositionId();
  if (f !== 0) {
    writer.writeUint32(
      9,
      f
    );
  }
};


/**
 * optional uint32 account_id = 1;
 * @return {number}
 */
proto.reportpb.CreateExerciseDeclarationRequest.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.CreateExerciseDeclarationRequest} returns this
 */
proto.reportpb.CreateExerciseDeclarationRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string sub_account_no = 2;
 * @return {string}
 */
proto.reportpb.CreateExerciseDeclarationRequest.prototype.getSubAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.CreateExerciseDeclarationRequest} returns this
 */
proto.reportpb.CreateExerciseDeclarationRequest.prototype.setSubAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string symbol = 3;
 * @return {string}
 */
proto.reportpb.CreateExerciseDeclarationRequest.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.CreateExerciseDeclarationRequest} returns this
 */
proto.reportpb.CreateExerciseDeclarationRequest.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string original_cusip = 4;
 * @return {string}
 */
proto.reportpb.CreateExerciseDeclarationRequest.prototype.getOriginalCusip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.CreateExerciseDeclarationRequest} returns this
 */
proto.reportpb.CreateExerciseDeclarationRequest.prototype.setOriginalCusip = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string eed = 5;
 * @return {string}
 */
proto.reportpb.CreateExerciseDeclarationRequest.prototype.getEed = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.CreateExerciseDeclarationRequest} returns this
 */
proto.reportpb.CreateExerciseDeclarationRequest.prototype.setEed = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string dned = 6;
 * @return {string}
 */
proto.reportpb.CreateExerciseDeclarationRequest.prototype.getDned = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.CreateExerciseDeclarationRequest} returns this
 */
proto.reportpb.CreateExerciseDeclarationRequest.prototype.setDned = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional google.type.Date system_date = 7;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.CreateExerciseDeclarationRequest.prototype.getSystemDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 7));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.CreateExerciseDeclarationRequest} returns this
*/
proto.reportpb.CreateExerciseDeclarationRequest.prototype.setSystemDate = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.CreateExerciseDeclarationRequest} returns this
 */
proto.reportpb.CreateExerciseDeclarationRequest.prototype.clearSystemDate = function() {
  return this.setSystemDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.CreateExerciseDeclarationRequest.prototype.hasSystemDate = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string status = 8;
 * @return {string}
 */
proto.reportpb.CreateExerciseDeclarationRequest.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.CreateExerciseDeclarationRequest} returns this
 */
proto.reportpb.CreateExerciseDeclarationRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional uint32 report_position_id = 9;
 * @return {number}
 */
proto.reportpb.CreateExerciseDeclarationRequest.prototype.getReportPositionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.CreateExerciseDeclarationRequest} returns this
 */
proto.reportpb.CreateExerciseDeclarationRequest.prototype.setReportPositionId = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.CreateExerciseDeclarationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.CreateExerciseDeclarationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.CreateExerciseDeclarationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.CreateExerciseDeclarationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    exerciseDeclaration: (f = msg.getExerciseDeclaration()) && proto.reportpb.ExerciseDeclaration.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.CreateExerciseDeclarationResponse}
 */
proto.reportpb.CreateExerciseDeclarationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.CreateExerciseDeclarationResponse;
  return proto.reportpb.CreateExerciseDeclarationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.CreateExerciseDeclarationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.CreateExerciseDeclarationResponse}
 */
proto.reportpb.CreateExerciseDeclarationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.reportpb.ExerciseDeclaration;
      reader.readMessage(value,proto.reportpb.ExerciseDeclaration.deserializeBinaryFromReader);
      msg.setExerciseDeclaration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.CreateExerciseDeclarationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.CreateExerciseDeclarationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.CreateExerciseDeclarationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.CreateExerciseDeclarationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExerciseDeclaration();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.reportpb.ExerciseDeclaration.serializeBinaryToWriter
    );
  }
};


/**
 * optional ExerciseDeclaration exercise_declaration = 1;
 * @return {?proto.reportpb.ExerciseDeclaration}
 */
proto.reportpb.CreateExerciseDeclarationResponse.prototype.getExerciseDeclaration = function() {
  return /** @type{?proto.reportpb.ExerciseDeclaration} */ (
    jspb.Message.getWrapperField(this, proto.reportpb.ExerciseDeclaration, 1));
};


/**
 * @param {?proto.reportpb.ExerciseDeclaration|undefined} value
 * @return {!proto.reportpb.CreateExerciseDeclarationResponse} returns this
*/
proto.reportpb.CreateExerciseDeclarationResponse.prototype.setExerciseDeclaration = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.CreateExerciseDeclarationResponse} returns this
 */
proto.reportpb.CreateExerciseDeclarationResponse.prototype.clearExerciseDeclaration = function() {
  return this.setExerciseDeclaration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.CreateExerciseDeclarationResponse.prototype.hasExerciseDeclaration = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.UpdateExerciseDeclarationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.UpdateExerciseDeclarationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.UpdateExerciseDeclarationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.UpdateExerciseDeclarationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contraryId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    eed: jspb.Message.getFieldWithDefault(msg, 2, ""),
    dned: jspb.Message.getFieldWithDefault(msg, 3, ""),
    systemDate: (f = msg.getSystemDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 5, ""),
    accountId: jspb.Message.getFieldWithDefault(msg, 6, 0),
    symbol: jspb.Message.getFieldWithDefault(msg, 7, ""),
    correspondent: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.UpdateExerciseDeclarationRequest}
 */
proto.reportpb.UpdateExerciseDeclarationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.UpdateExerciseDeclarationRequest;
  return proto.reportpb.UpdateExerciseDeclarationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.UpdateExerciseDeclarationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.UpdateExerciseDeclarationRequest}
 */
proto.reportpb.UpdateExerciseDeclarationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setContraryId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEed(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDned(value);
      break;
    case 4:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setSystemDate(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAccountId(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorrespondent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.UpdateExerciseDeclarationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.UpdateExerciseDeclarationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.UpdateExerciseDeclarationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.UpdateExerciseDeclarationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContraryId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getEed();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDned();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSystemDate();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCorrespondent();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional uint32 contrary_id = 1;
 * @return {number}
 */
proto.reportpb.UpdateExerciseDeclarationRequest.prototype.getContraryId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.UpdateExerciseDeclarationRequest} returns this
 */
proto.reportpb.UpdateExerciseDeclarationRequest.prototype.setContraryId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string eed = 2;
 * @return {string}
 */
proto.reportpb.UpdateExerciseDeclarationRequest.prototype.getEed = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.UpdateExerciseDeclarationRequest} returns this
 */
proto.reportpb.UpdateExerciseDeclarationRequest.prototype.setEed = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string dned = 3;
 * @return {string}
 */
proto.reportpb.UpdateExerciseDeclarationRequest.prototype.getDned = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.UpdateExerciseDeclarationRequest} returns this
 */
proto.reportpb.UpdateExerciseDeclarationRequest.prototype.setDned = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.type.Date system_date = 4;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.UpdateExerciseDeclarationRequest.prototype.getSystemDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 4));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.UpdateExerciseDeclarationRequest} returns this
*/
proto.reportpb.UpdateExerciseDeclarationRequest.prototype.setSystemDate = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.UpdateExerciseDeclarationRequest} returns this
 */
proto.reportpb.UpdateExerciseDeclarationRequest.prototype.clearSystemDate = function() {
  return this.setSystemDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.UpdateExerciseDeclarationRequest.prototype.hasSystemDate = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string status = 5;
 * @return {string}
 */
proto.reportpb.UpdateExerciseDeclarationRequest.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.UpdateExerciseDeclarationRequest} returns this
 */
proto.reportpb.UpdateExerciseDeclarationRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional uint32 account_id = 6;
 * @return {number}
 */
proto.reportpb.UpdateExerciseDeclarationRequest.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.UpdateExerciseDeclarationRequest} returns this
 */
proto.reportpb.UpdateExerciseDeclarationRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string symbol = 7;
 * @return {string}
 */
proto.reportpb.UpdateExerciseDeclarationRequest.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.UpdateExerciseDeclarationRequest} returns this
 */
proto.reportpb.UpdateExerciseDeclarationRequest.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string correspondent = 8;
 * @return {string}
 */
proto.reportpb.UpdateExerciseDeclarationRequest.prototype.getCorrespondent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.UpdateExerciseDeclarationRequest} returns this
 */
proto.reportpb.UpdateExerciseDeclarationRequest.prototype.setCorrespondent = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.UpdateExerciseDeclarationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.UpdateExerciseDeclarationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.UpdateExerciseDeclarationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.UpdateExerciseDeclarationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    exerciseDeclaration: (f = msg.getExerciseDeclaration()) && proto.reportpb.ExerciseDeclaration.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.UpdateExerciseDeclarationResponse}
 */
proto.reportpb.UpdateExerciseDeclarationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.UpdateExerciseDeclarationResponse;
  return proto.reportpb.UpdateExerciseDeclarationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.UpdateExerciseDeclarationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.UpdateExerciseDeclarationResponse}
 */
proto.reportpb.UpdateExerciseDeclarationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.reportpb.ExerciseDeclaration;
      reader.readMessage(value,proto.reportpb.ExerciseDeclaration.deserializeBinaryFromReader);
      msg.setExerciseDeclaration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.UpdateExerciseDeclarationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.UpdateExerciseDeclarationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.UpdateExerciseDeclarationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.UpdateExerciseDeclarationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExerciseDeclaration();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.reportpb.ExerciseDeclaration.serializeBinaryToWriter
    );
  }
};


/**
 * optional ExerciseDeclaration exercise_declaration = 1;
 * @return {?proto.reportpb.ExerciseDeclaration}
 */
proto.reportpb.UpdateExerciseDeclarationResponse.prototype.getExerciseDeclaration = function() {
  return /** @type{?proto.reportpb.ExerciseDeclaration} */ (
    jspb.Message.getWrapperField(this, proto.reportpb.ExerciseDeclaration, 1));
};


/**
 * @param {?proto.reportpb.ExerciseDeclaration|undefined} value
 * @return {!proto.reportpb.UpdateExerciseDeclarationResponse} returns this
*/
proto.reportpb.UpdateExerciseDeclarationResponse.prototype.setExerciseDeclaration = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.UpdateExerciseDeclarationResponse} returns this
 */
proto.reportpb.UpdateExerciseDeclarationResponse.prototype.clearExerciseDeclaration = function() {
  return this.setExerciseDeclaration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.UpdateExerciseDeclarationResponse.prototype.hasExerciseDeclaration = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.CreateExerciseNoticeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.CreateExerciseNoticeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.CreateExerciseNoticeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.CreateExerciseNoticeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    subAccountNo: jspb.Message.getFieldWithDefault(msg, 2, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 3, ""),
    originalCusip: jspb.Message.getFieldWithDefault(msg, 4, ""),
    exerciseQty: jspb.Message.getFieldWithDefault(msg, 5, ""),
    systemDate: (f = msg.getSystemDate()) && google_type_date_pb.Date.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.CreateExerciseNoticeRequest}
 */
proto.reportpb.CreateExerciseNoticeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.CreateExerciseNoticeRequest;
  return proto.reportpb.CreateExerciseNoticeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.CreateExerciseNoticeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.CreateExerciseNoticeRequest}
 */
proto.reportpb.CreateExerciseNoticeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubAccountNo(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOriginalCusip(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setExerciseQty(value);
      break;
    case 6:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setSystemDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.CreateExerciseNoticeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.CreateExerciseNoticeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.CreateExerciseNoticeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.CreateExerciseNoticeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getSubAccountNo();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOriginalCusip();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getExerciseQty();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSystemDate();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 account_id = 1;
 * @return {number}
 */
proto.reportpb.CreateExerciseNoticeRequest.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.CreateExerciseNoticeRequest} returns this
 */
proto.reportpb.CreateExerciseNoticeRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string sub_account_no = 2;
 * @return {string}
 */
proto.reportpb.CreateExerciseNoticeRequest.prototype.getSubAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.CreateExerciseNoticeRequest} returns this
 */
proto.reportpb.CreateExerciseNoticeRequest.prototype.setSubAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string symbol = 3;
 * @return {string}
 */
proto.reportpb.CreateExerciseNoticeRequest.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.CreateExerciseNoticeRequest} returns this
 */
proto.reportpb.CreateExerciseNoticeRequest.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string original_cusip = 4;
 * @return {string}
 */
proto.reportpb.CreateExerciseNoticeRequest.prototype.getOriginalCusip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.CreateExerciseNoticeRequest} returns this
 */
proto.reportpb.CreateExerciseNoticeRequest.prototype.setOriginalCusip = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string exercise_qty = 5;
 * @return {string}
 */
proto.reportpb.CreateExerciseNoticeRequest.prototype.getExerciseQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.CreateExerciseNoticeRequest} returns this
 */
proto.reportpb.CreateExerciseNoticeRequest.prototype.setExerciseQty = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional google.type.Date system_date = 6;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.CreateExerciseNoticeRequest.prototype.getSystemDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 6));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.CreateExerciseNoticeRequest} returns this
*/
proto.reportpb.CreateExerciseNoticeRequest.prototype.setSystemDate = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.CreateExerciseNoticeRequest} returns this
 */
proto.reportpb.CreateExerciseNoticeRequest.prototype.clearSystemDate = function() {
  return this.setSystemDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.CreateExerciseNoticeRequest.prototype.hasSystemDate = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.CreateExerciseNoticeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.CreateExerciseNoticeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.CreateExerciseNoticeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.CreateExerciseNoticeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    exerciseDeclaration: (f = msg.getExerciseDeclaration()) && proto.reportpb.ExerciseDeclaration.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.CreateExerciseNoticeResponse}
 */
proto.reportpb.CreateExerciseNoticeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.CreateExerciseNoticeResponse;
  return proto.reportpb.CreateExerciseNoticeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.CreateExerciseNoticeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.CreateExerciseNoticeResponse}
 */
proto.reportpb.CreateExerciseNoticeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.reportpb.ExerciseDeclaration;
      reader.readMessage(value,proto.reportpb.ExerciseDeclaration.deserializeBinaryFromReader);
      msg.setExerciseDeclaration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.CreateExerciseNoticeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.CreateExerciseNoticeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.CreateExerciseNoticeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.CreateExerciseNoticeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExerciseDeclaration();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.reportpb.ExerciseDeclaration.serializeBinaryToWriter
    );
  }
};


/**
 * optional ExerciseDeclaration exercise_declaration = 1;
 * @return {?proto.reportpb.ExerciseDeclaration}
 */
proto.reportpb.CreateExerciseNoticeResponse.prototype.getExerciseDeclaration = function() {
  return /** @type{?proto.reportpb.ExerciseDeclaration} */ (
    jspb.Message.getWrapperField(this, proto.reportpb.ExerciseDeclaration, 1));
};


/**
 * @param {?proto.reportpb.ExerciseDeclaration|undefined} value
 * @return {!proto.reportpb.CreateExerciseNoticeResponse} returns this
*/
proto.reportpb.CreateExerciseNoticeResponse.prototype.setExerciseDeclaration = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.CreateExerciseNoticeResponse} returns this
 */
proto.reportpb.CreateExerciseNoticeResponse.prototype.clearExerciseDeclaration = function() {
  return this.setExerciseDeclaration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.CreateExerciseNoticeResponse.prototype.hasExerciseDeclaration = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.UpdateExerciseNoticeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.UpdateExerciseNoticeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.UpdateExerciseNoticeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.UpdateExerciseNoticeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contraryId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    exerciseQty: jspb.Message.getFieldWithDefault(msg, 2, ""),
    systemDate: (f = msg.getSystemDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    accountId: jspb.Message.getFieldWithDefault(msg, 4, 0),
    symbol: jspb.Message.getFieldWithDefault(msg, 5, ""),
    correspondent: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.UpdateExerciseNoticeRequest}
 */
proto.reportpb.UpdateExerciseNoticeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.UpdateExerciseNoticeRequest;
  return proto.reportpb.UpdateExerciseNoticeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.UpdateExerciseNoticeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.UpdateExerciseNoticeRequest}
 */
proto.reportpb.UpdateExerciseNoticeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setContraryId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setExerciseQty(value);
      break;
    case 3:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setSystemDate(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAccountId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorrespondent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.UpdateExerciseNoticeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.UpdateExerciseNoticeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.UpdateExerciseNoticeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.UpdateExerciseNoticeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContraryId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getExerciseQty();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSystemDate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCorrespondent();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional uint32 contrary_id = 1;
 * @return {number}
 */
proto.reportpb.UpdateExerciseNoticeRequest.prototype.getContraryId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.UpdateExerciseNoticeRequest} returns this
 */
proto.reportpb.UpdateExerciseNoticeRequest.prototype.setContraryId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string exercise_qty = 2;
 * @return {string}
 */
proto.reportpb.UpdateExerciseNoticeRequest.prototype.getExerciseQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.UpdateExerciseNoticeRequest} returns this
 */
proto.reportpb.UpdateExerciseNoticeRequest.prototype.setExerciseQty = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.type.Date system_date = 3;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.UpdateExerciseNoticeRequest.prototype.getSystemDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 3));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.UpdateExerciseNoticeRequest} returns this
*/
proto.reportpb.UpdateExerciseNoticeRequest.prototype.setSystemDate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.UpdateExerciseNoticeRequest} returns this
 */
proto.reportpb.UpdateExerciseNoticeRequest.prototype.clearSystemDate = function() {
  return this.setSystemDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.UpdateExerciseNoticeRequest.prototype.hasSystemDate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional uint32 account_id = 4;
 * @return {number}
 */
proto.reportpb.UpdateExerciseNoticeRequest.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.UpdateExerciseNoticeRequest} returns this
 */
proto.reportpb.UpdateExerciseNoticeRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string symbol = 5;
 * @return {string}
 */
proto.reportpb.UpdateExerciseNoticeRequest.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.UpdateExerciseNoticeRequest} returns this
 */
proto.reportpb.UpdateExerciseNoticeRequest.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string correspondent = 6;
 * @return {string}
 */
proto.reportpb.UpdateExerciseNoticeRequest.prototype.getCorrespondent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.UpdateExerciseNoticeRequest} returns this
 */
proto.reportpb.UpdateExerciseNoticeRequest.prototype.setCorrespondent = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.UpdateExerciseNoticeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.UpdateExerciseNoticeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.UpdateExerciseNoticeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.UpdateExerciseNoticeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    exerciseDeclaration: (f = msg.getExerciseDeclaration()) && proto.reportpb.ExerciseDeclaration.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.UpdateExerciseNoticeResponse}
 */
proto.reportpb.UpdateExerciseNoticeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.UpdateExerciseNoticeResponse;
  return proto.reportpb.UpdateExerciseNoticeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.UpdateExerciseNoticeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.UpdateExerciseNoticeResponse}
 */
proto.reportpb.UpdateExerciseNoticeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.reportpb.ExerciseDeclaration;
      reader.readMessage(value,proto.reportpb.ExerciseDeclaration.deserializeBinaryFromReader);
      msg.setExerciseDeclaration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.UpdateExerciseNoticeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.UpdateExerciseNoticeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.UpdateExerciseNoticeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.UpdateExerciseNoticeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExerciseDeclaration();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.reportpb.ExerciseDeclaration.serializeBinaryToWriter
    );
  }
};


/**
 * optional ExerciseDeclaration exercise_declaration = 1;
 * @return {?proto.reportpb.ExerciseDeclaration}
 */
proto.reportpb.UpdateExerciseNoticeResponse.prototype.getExerciseDeclaration = function() {
  return /** @type{?proto.reportpb.ExerciseDeclaration} */ (
    jspb.Message.getWrapperField(this, proto.reportpb.ExerciseDeclaration, 1));
};


/**
 * @param {?proto.reportpb.ExerciseDeclaration|undefined} value
 * @return {!proto.reportpb.UpdateExerciseNoticeResponse} returns this
*/
proto.reportpb.UpdateExerciseNoticeResponse.prototype.setExerciseDeclaration = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.UpdateExerciseNoticeResponse} returns this
 */
proto.reportpb.UpdateExerciseNoticeResponse.prototype.clearExerciseDeclaration = function() {
  return this.setExerciseDeclaration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.UpdateExerciseNoticeResponse.prototype.hasExerciseDeclaration = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ExerciseDeclarationDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ExerciseDeclarationDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ExerciseDeclarationDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    contraryId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    accountId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    correspondent: jspb.Message.getFieldWithDefault(msg, 3, ""),
    accountName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    rep: jspb.Message.getFieldWithDefault(msg, 5, ""),
    branch: jspb.Message.getFieldWithDefault(msg, 6, ""),
    accountNo: jspb.Message.getFieldWithDefault(msg, 7, ""),
    marginType: jspb.Message.getFieldWithDefault(msg, 8, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 9, ""),
    symbolDescription: jspb.Message.getFieldWithDefault(msg, 10, ""),
    originalCusip: jspb.Message.getFieldWithDefault(msg, 11, ""),
    tdQty: jspb.Message.getFieldWithDefault(msg, 12, ""),
    exerciseQty: jspb.Message.getFieldWithDefault(msg, 13, ""),
    eed: jspb.Message.getFieldWithDefault(msg, 14, ""),
    dned: jspb.Message.getFieldWithDefault(msg, 15, ""),
    systemDate: (f = msg.getSystemDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    expirationDate: jspb.Message.getFieldWithDefault(msg, 17, ""),
    positionQty: jspb.Message.getFieldWithDefault(msg, 18, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ExerciseDeclarationDetails}
 */
proto.reportpb.ExerciseDeclarationDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ExerciseDeclarationDetails;
  return proto.reportpb.ExerciseDeclarationDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ExerciseDeclarationDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ExerciseDeclarationDetails}
 */
proto.reportpb.ExerciseDeclarationDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setContraryId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorrespondent(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setRep(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setBranch(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNo(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarginType(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolDescription(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setOriginalCusip(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setTdQty(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setExerciseQty(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setEed(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setDned(value);
      break;
    case 16:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setSystemDate(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setExpirationDate(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setPositionQty(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ExerciseDeclarationDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ExerciseDeclarationDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ExerciseDeclarationDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContraryId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getCorrespondent();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAccountName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRep();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getBranch();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAccountNo();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getMarginType();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getSymbolDescription();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getOriginalCusip();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getTdQty();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getExerciseQty();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getEed();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getDned();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getSystemDate();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getExpirationDate();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getPositionQty();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
};


/**
 * optional uint32 contrary_id = 1;
 * @return {number}
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.getContraryId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.ExerciseDeclarationDetails} returns this
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.setContraryId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 account_id = 2;
 * @return {number}
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.ExerciseDeclarationDetails} returns this
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string correspondent = 3;
 * @return {string}
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.getCorrespondent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ExerciseDeclarationDetails} returns this
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.setCorrespondent = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string account_name = 4;
 * @return {string}
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.getAccountName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ExerciseDeclarationDetails} returns this
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.setAccountName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string rep = 5;
 * @return {string}
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.getRep = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ExerciseDeclarationDetails} returns this
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.setRep = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string branch = 6;
 * @return {string}
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.getBranch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ExerciseDeclarationDetails} returns this
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.setBranch = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string account_no = 7;
 * @return {string}
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.getAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ExerciseDeclarationDetails} returns this
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.setAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string margin_type = 8;
 * @return {string}
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.getMarginType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ExerciseDeclarationDetails} returns this
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.setMarginType = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string symbol = 9;
 * @return {string}
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ExerciseDeclarationDetails} returns this
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string symbol_description = 10;
 * @return {string}
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.getSymbolDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ExerciseDeclarationDetails} returns this
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.setSymbolDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string original_cusip = 11;
 * @return {string}
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.getOriginalCusip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ExerciseDeclarationDetails} returns this
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.setOriginalCusip = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string td_qty = 12;
 * @return {string}
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.getTdQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ExerciseDeclarationDetails} returns this
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.setTdQty = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string exercise_qty = 13;
 * @return {string}
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.getExerciseQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ExerciseDeclarationDetails} returns this
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.setExerciseQty = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string eed = 14;
 * @return {string}
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.getEed = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ExerciseDeclarationDetails} returns this
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.setEed = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string dned = 15;
 * @return {string}
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.getDned = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ExerciseDeclarationDetails} returns this
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.setDned = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional google.type.Date system_date = 16;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.getSystemDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 16));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ExerciseDeclarationDetails} returns this
*/
proto.reportpb.ExerciseDeclarationDetails.prototype.setSystemDate = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ExerciseDeclarationDetails} returns this
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.clearSystemDate = function() {
  return this.setSystemDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.hasSystemDate = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional string expiration_date = 17;
 * @return {string}
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.getExpirationDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ExerciseDeclarationDetails} returns this
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.setExpirationDate = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string position_qty = 18;
 * @return {string}
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.getPositionQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ExerciseDeclarationDetails} returns this
 */
proto.reportpb.ExerciseDeclarationDetails.prototype.setPositionQty = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ReadExerciseDeclarationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ReadExerciseDeclarationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ReadExerciseDeclarationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ReadExerciseDeclarationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    subAccountNo: jspb.Message.getFieldWithDefault(msg, 2, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 3, ""),
    originalCusip: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ReadExerciseDeclarationRequest}
 */
proto.reportpb.ReadExerciseDeclarationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ReadExerciseDeclarationRequest;
  return proto.reportpb.ReadExerciseDeclarationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ReadExerciseDeclarationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ReadExerciseDeclarationRequest}
 */
proto.reportpb.ReadExerciseDeclarationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubAccountNo(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOriginalCusip(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ReadExerciseDeclarationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ReadExerciseDeclarationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ReadExerciseDeclarationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ReadExerciseDeclarationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getSubAccountNo();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOriginalCusip();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional uint32 account_id = 1;
 * @return {number}
 */
proto.reportpb.ReadExerciseDeclarationRequest.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.ReadExerciseDeclarationRequest} returns this
 */
proto.reportpb.ReadExerciseDeclarationRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string sub_account_no = 2;
 * @return {string}
 */
proto.reportpb.ReadExerciseDeclarationRequest.prototype.getSubAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ReadExerciseDeclarationRequest} returns this
 */
proto.reportpb.ReadExerciseDeclarationRequest.prototype.setSubAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string symbol = 3;
 * @return {string}
 */
proto.reportpb.ReadExerciseDeclarationRequest.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ReadExerciseDeclarationRequest} returns this
 */
proto.reportpb.ReadExerciseDeclarationRequest.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string original_cusip = 4;
 * @return {string}
 */
proto.reportpb.ReadExerciseDeclarationRequest.prototype.getOriginalCusip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ReadExerciseDeclarationRequest} returns this
 */
proto.reportpb.ReadExerciseDeclarationRequest.prototype.setOriginalCusip = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.reportpb.ReadExerciseDeclarationResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ReadExerciseDeclarationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ReadExerciseDeclarationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ReadExerciseDeclarationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ReadExerciseDeclarationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    declarationDetailsList: jspb.Message.toObjectList(msg.getDeclarationDetailsList(),
    proto.reportpb.ExerciseDeclarationDetails.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ReadExerciseDeclarationResponse}
 */
proto.reportpb.ReadExerciseDeclarationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ReadExerciseDeclarationResponse;
  return proto.reportpb.ReadExerciseDeclarationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ReadExerciseDeclarationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ReadExerciseDeclarationResponse}
 */
proto.reportpb.ReadExerciseDeclarationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.reportpb.ExerciseDeclarationDetails;
      reader.readMessage(value,proto.reportpb.ExerciseDeclarationDetails.deserializeBinaryFromReader);
      msg.addDeclarationDetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ReadExerciseDeclarationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ReadExerciseDeclarationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ReadExerciseDeclarationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ReadExerciseDeclarationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDeclarationDetailsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.reportpb.ExerciseDeclarationDetails.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ExerciseDeclarationDetails declaration_details = 1;
 * @return {!Array<!proto.reportpb.ExerciseDeclarationDetails>}
 */
proto.reportpb.ReadExerciseDeclarationResponse.prototype.getDeclarationDetailsList = function() {
  return /** @type{!Array<!proto.reportpb.ExerciseDeclarationDetails>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.reportpb.ExerciseDeclarationDetails, 1));
};


/**
 * @param {!Array<!proto.reportpb.ExerciseDeclarationDetails>} value
 * @return {!proto.reportpb.ReadExerciseDeclarationResponse} returns this
*/
proto.reportpb.ReadExerciseDeclarationResponse.prototype.setDeclarationDetailsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.reportpb.ExerciseDeclarationDetails=} opt_value
 * @param {number=} opt_index
 * @return {!proto.reportpb.ExerciseDeclarationDetails}
 */
proto.reportpb.ReadExerciseDeclarationResponse.prototype.addDeclarationDetails = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.reportpb.ExerciseDeclarationDetails, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.reportpb.ReadExerciseDeclarationResponse} returns this
 */
proto.reportpb.ReadExerciseDeclarationResponse.prototype.clearDeclarationDetailsList = function() {
  return this.setDeclarationDetailsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ReadExerciseNoticeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ReadExerciseNoticeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ReadExerciseNoticeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ReadExerciseNoticeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    subAccountNo: jspb.Message.getFieldWithDefault(msg, 2, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 3, ""),
    originalCusip: jspb.Message.getFieldWithDefault(msg, 4, ""),
    pagination: (f = msg.getPagination()) && proto_utilspb_pagination_pb.Pagination.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ReadExerciseNoticeRequest}
 */
proto.reportpb.ReadExerciseNoticeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ReadExerciseNoticeRequest;
  return proto.reportpb.ReadExerciseNoticeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ReadExerciseNoticeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ReadExerciseNoticeRequest}
 */
proto.reportpb.ReadExerciseNoticeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubAccountNo(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOriginalCusip(value);
      break;
    case 5:
      var value = new proto_utilspb_pagination_pb.Pagination;
      reader.readMessage(value,proto_utilspb_pagination_pb.Pagination.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ReadExerciseNoticeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ReadExerciseNoticeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ReadExerciseNoticeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ReadExerciseNoticeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getSubAccountNo();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOriginalCusip();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto_utilspb_pagination_pb.Pagination.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 account_id = 1;
 * @return {number}
 */
proto.reportpb.ReadExerciseNoticeRequest.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.ReadExerciseNoticeRequest} returns this
 */
proto.reportpb.ReadExerciseNoticeRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string sub_account_no = 2;
 * @return {string}
 */
proto.reportpb.ReadExerciseNoticeRequest.prototype.getSubAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ReadExerciseNoticeRequest} returns this
 */
proto.reportpb.ReadExerciseNoticeRequest.prototype.setSubAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string symbol = 3;
 * @return {string}
 */
proto.reportpb.ReadExerciseNoticeRequest.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ReadExerciseNoticeRequest} returns this
 */
proto.reportpb.ReadExerciseNoticeRequest.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string original_cusip = 4;
 * @return {string}
 */
proto.reportpb.ReadExerciseNoticeRequest.prototype.getOriginalCusip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ReadExerciseNoticeRequest} returns this
 */
proto.reportpb.ReadExerciseNoticeRequest.prototype.setOriginalCusip = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional utilspb.Pagination pagination = 5;
 * @return {?proto.utilspb.Pagination}
 */
proto.reportpb.ReadExerciseNoticeRequest.prototype.getPagination = function() {
  return /** @type{?proto.utilspb.Pagination} */ (
    jspb.Message.getWrapperField(this, proto_utilspb_pagination_pb.Pagination, 5));
};


/**
 * @param {?proto.utilspb.Pagination|undefined} value
 * @return {!proto.reportpb.ReadExerciseNoticeRequest} returns this
*/
proto.reportpb.ReadExerciseNoticeRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ReadExerciseNoticeRequest} returns this
 */
proto.reportpb.ReadExerciseNoticeRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ReadExerciseNoticeRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ReadExerciseNoticeSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ReadExerciseNoticeSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ReadExerciseNoticeSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ReadExerciseNoticeSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    totalRows: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ReadExerciseNoticeSummary}
 */
proto.reportpb.ReadExerciseNoticeSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ReadExerciseNoticeSummary;
  return proto.reportpb.ReadExerciseNoticeSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ReadExerciseNoticeSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ReadExerciseNoticeSummary}
 */
proto.reportpb.ReadExerciseNoticeSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTotalRows(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ReadExerciseNoticeSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ReadExerciseNoticeSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ReadExerciseNoticeSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ReadExerciseNoticeSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalRows();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 total_rows = 1;
 * @return {number}
 */
proto.reportpb.ReadExerciseNoticeSummary.prototype.getTotalRows = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.ReadExerciseNoticeSummary} returns this
 */
proto.reportpb.ReadExerciseNoticeSummary.prototype.setTotalRows = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.reportpb.ReadExerciseNoticeResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ReadExerciseNoticeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ReadExerciseNoticeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ReadExerciseNoticeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ReadExerciseNoticeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    declarationDetailsList: jspb.Message.toObjectList(msg.getDeclarationDetailsList(),
    proto.reportpb.ExerciseDeclarationDetails.toObject, includeInstance),
    summary: (f = msg.getSummary()) && proto.reportpb.ReadExerciseNoticeSummary.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ReadExerciseNoticeResponse}
 */
proto.reportpb.ReadExerciseNoticeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ReadExerciseNoticeResponse;
  return proto.reportpb.ReadExerciseNoticeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ReadExerciseNoticeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ReadExerciseNoticeResponse}
 */
proto.reportpb.ReadExerciseNoticeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.reportpb.ExerciseDeclarationDetails;
      reader.readMessage(value,proto.reportpb.ExerciseDeclarationDetails.deserializeBinaryFromReader);
      msg.addDeclarationDetails(value);
      break;
    case 2:
      var value = new proto.reportpb.ReadExerciseNoticeSummary;
      reader.readMessage(value,proto.reportpb.ReadExerciseNoticeSummary.deserializeBinaryFromReader);
      msg.setSummary(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ReadExerciseNoticeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ReadExerciseNoticeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ReadExerciseNoticeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ReadExerciseNoticeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDeclarationDetailsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.reportpb.ExerciseDeclarationDetails.serializeBinaryToWriter
    );
  }
  f = message.getSummary();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.reportpb.ReadExerciseNoticeSummary.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ExerciseDeclarationDetails declaration_details = 1;
 * @return {!Array<!proto.reportpb.ExerciseDeclarationDetails>}
 */
proto.reportpb.ReadExerciseNoticeResponse.prototype.getDeclarationDetailsList = function() {
  return /** @type{!Array<!proto.reportpb.ExerciseDeclarationDetails>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.reportpb.ExerciseDeclarationDetails, 1));
};


/**
 * @param {!Array<!proto.reportpb.ExerciseDeclarationDetails>} value
 * @return {!proto.reportpb.ReadExerciseNoticeResponse} returns this
*/
proto.reportpb.ReadExerciseNoticeResponse.prototype.setDeclarationDetailsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.reportpb.ExerciseDeclarationDetails=} opt_value
 * @param {number=} opt_index
 * @return {!proto.reportpb.ExerciseDeclarationDetails}
 */
proto.reportpb.ReadExerciseNoticeResponse.prototype.addDeclarationDetails = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.reportpb.ExerciseDeclarationDetails, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.reportpb.ReadExerciseNoticeResponse} returns this
 */
proto.reportpb.ReadExerciseNoticeResponse.prototype.clearDeclarationDetailsList = function() {
  return this.setDeclarationDetailsList([]);
};


/**
 * optional ReadExerciseNoticeSummary summary = 2;
 * @return {?proto.reportpb.ReadExerciseNoticeSummary}
 */
proto.reportpb.ReadExerciseNoticeResponse.prototype.getSummary = function() {
  return /** @type{?proto.reportpb.ReadExerciseNoticeSummary} */ (
    jspb.Message.getWrapperField(this, proto.reportpb.ReadExerciseNoticeSummary, 2));
};


/**
 * @param {?proto.reportpb.ReadExerciseNoticeSummary|undefined} value
 * @return {!proto.reportpb.ReadExerciseNoticeResponse} returns this
*/
proto.reportpb.ReadExerciseNoticeResponse.prototype.setSummary = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ReadExerciseNoticeResponse} returns this
 */
proto.reportpb.ReadExerciseNoticeResponse.prototype.clearSummary = function() {
  return this.setSummary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ReadExerciseNoticeResponse.prototype.hasSummary = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.reportpb);
